cv.PublicBehavior = Marionette.Behavior.extend({
  // you can set default options
  // just like you can in your Backbone Models
  // they will be overriden if you pass in an option with the same key
  defaults: {
  },

  // behaviors have events that are bound to the views DOM
  events: {
    'click .cv-share' : 'share',
    'click .cv-login' : 'login',
    'click .cv-signup' : 'signup'
  },

  initialize: function(){
    console.log('PublicBehavior initialized.');
  },

  share: function(e){
    e.preventDefault();

    // Load the modal
    var view = new cv.ShareView({
      url : $(e.currentTarget).attr('data-url')
    });
    vent.trigger('modal:show', view);
  },

  login: function(e){
    e.preventDefault();

    top.location = '//' + cv.campaign.get('url') + '/login';
  },
  
  signup: function(e){
    e.preventDefault();
  
    top.location = '//' + cv.campaign.get('url') + '/signup';
  },
  
  donate: function(e){
    e.preventDefault();

    var url = $(e.currentTarget).attr('data-url');
    if(url != ''){
      if(cv.environment == 'development'){
        top.location = 'https://secure.cvox.local/pay?url=' + url.replace(/\/$/, "");;
      }
      if(cv.environment == 'staging'){
        top.location = 'https://secure.cvoxstaging.com/pay?url=' + url.replace(/\/$/, "");;
      }
      if(cv.environment == 'demo'){
        top.location = 'https://secure.cvoxdemo.com/pay?url=' + url.replace(/\/$/, "");;
      }
      if(cv.environment == 'production'){
        top.location = 'https://secure.causevox.com/pay?url=' + url.replace(/\/$/, "");;
      }
    }
  }
});